import { Container } from "@/backend/models/containers/container";
import { Operation } from "@/backend/models/operation";
import { Parameter } from "@/backend/models/parameter";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { CopyPasteTypes, copyPasteTypes } from "@/types/copyPasteTypes";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getPasteError } from "../../utils/getPasteError";
import { ProcedureInstanceBase } from "@/backend/models/procedureInstances/procedureInstanceBase";

export function PasteItem(props: { item: Operation | Container | Parameter | ProcedureInstanceBase, instance: CopyPasteTypes, isScaffold: boolean }) {
  const { item, instance, isScaffold } = props;
  const copiedItem = useGlobalStore((state) => state.copiedItem);
  const containerLookup = useTreeStore((state) => state.containerLookup);
  const rootId = useTreeStore((state) => state.rootId);
  const pasteItem = useTreeStore((state) => state.pasteItem);
  const targetItem = { id: item.id, type: instance, isScaffold };
  const pasteError = getPasteError(targetItem, copiedItem, containerLookup, rootId);

  const onClickPaste = () => {
    if (copiedItem && !pasteError) {
      void pasteItem({ copiedItem, targetItem });
    }
  };

  const pasteMessage = (targetItem.type === copyPasteTypes.Step && copiedItem?.type === copyPasteTypes.Section) ? I18n.get('pasteBelowStep', { model: I18n.get(copiedItem?.type || '') }) : I18n.get('paste', { model: I18n.get(copiedItem?.type || '') });

  return (
    <Dropdown.Item onClick={onClickPaste}>
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={pasteError ? <Tooltip>{pasteError}</Tooltip> : <div/>}
      >
        <div className={pasteError ? 'text-secondary' : ''}>
          {pasteMessage}
        </div>
      </OverlayTrigger>
    </Dropdown.Item>
  );
}
